import React from "react";

// value widgets
import MuiTextWidget from "./value/MuiText";
import MuiTextAreaWidget from "./value/MuiTextArea";
import MuiDateWidget from "./value/MuiDate";
import MuiDateTimeWidget from "./value/MuiDateTime";
import MuiTimeWidget from "./value/MuiTime";
import MuiSelectWidget from "./value/MuiSelect";
import MuiNumberWidget from "./value/MuiNumber";
import MuiPriceWidget from "./value/MuiPrice";
import MuiSliderWidget from "./value/MuiSlider";
import MuiRangeWidget from "./value/MuiRange";
import MuiBooleanWidget from "./value/MuiBoolean";
import MuiMultiSelectWidget from "./value/MuiMultiSelect";
import MuiAutocompleteWidget from "./value/MuiAutocomplete";

// field select widgets
import MuiFieldSelect from "./core/MuiFieldSelect";
import MuiFieldAutocomplete from "./core/MuiFieldAutocomplete";

// core components
import MuiIcon from "./core/MuiIcon";
import MuiButton from "./core/MuiButton";
import MuiButtonGroup from "./core/MuiButtonGroup";
import MuiConjs from "./core/MuiConjs";
import MuiSwitch from "./core/MuiSwitch";
import MuiValueSources from "./core/MuiValueSources";
import { MuiConfirm, MuiUseConfirm } from "./core/MuiConfirm";
import { MuiProvider } from "./core/MuiProvider";
var MuiWidgets = {
  MuiTextWidget: MuiTextWidget,
  MuiTextAreaWidget: MuiTextAreaWidget,
  MuiDateWidget: MuiDateWidget,
  MuiDateTimeWidget: MuiDateTimeWidget,
  MuiTimeWidget: MuiTimeWidget,
  MuiSelectWidget: MuiSelectWidget,
  MuiNumberWidget: MuiNumberWidget,
  MuiPriceWidget: MuiPriceWidget,
  MuiSliderWidget: MuiSliderWidget,
  MuiRangeWidget: MuiRangeWidget,
  MuiBooleanWidget: MuiBooleanWidget,
  MuiMultiSelectWidget: MuiMultiSelectWidget,
  MuiAutocompleteWidget: MuiAutocompleteWidget,
  MuiFieldSelect: MuiFieldSelect,
  MuiFieldAutocomplete: MuiFieldAutocomplete,
  MuiIcon: MuiIcon,
  MuiButton: MuiButton,
  MuiButtonGroup: MuiButtonGroup,
  MuiConjs: MuiConjs,
  MuiSwitch: MuiSwitch,
  MuiValueSources: MuiValueSources,
  MuiConfirm: MuiConfirm,
  MuiUseConfirm: MuiUseConfirm,
  MuiProvider: MuiProvider
};
export default MuiWidgets;